var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissingThings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "447px",
    height: "291px",
    viewBox: "0 0 447 291",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.627 0.415 24.167 0.415 24.167 15.743 0.627 15.743"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0.892 170.745 0.892 170.745 155 0 155"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(15.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(102.735047, 87.969658) scale(-1, 1) rotate(-4.000000) translate(-102.735047, -87.969658) translate(5.735047, 6.969658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(88.509141, 80.976514) rotate(2.000000) translate(-88.509141, -80.976514) translate(3.009141, 3.476514)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(169.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.627,9.3 L3.297,15.743 C3.297,15.743 18.37,8.784 24.167,0.415 L0.627,9.301 L0.627,9.3 Z",
    id: "Shape",
    fill: "#A6ACBA",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(5.765937, 0.539818)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.457,18.094 L169.641,8.066 C169.641,8.066 157.214,-2.674 132.593,3.532 C132.593,3.532 116.34,43.636 103.434,55.095 L6.632,129.574 C6.632,129.574 2.327,135.782 3.046,140.557 C3.762,145.329 9.976,152.492 16.67,152.015 C23.362,151.537 25.513,147.478 28.143,145.569 C30.773,143.659 120.643,69.179 120.643,69.179 C124.408829,67.6218262 128.295377,66.3743582 132.264,65.449 C141.893,63.209 150.37,63.259 156.618,63.853 C157.482,63.877 158.586,63.816 159.83,63.524 C161.411166,63.1517249 162.906866,62.4814263 164.237,61.549 L146.457,18.094",
    id: "Shape",
    fill: "#A6ACBA",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(214.000000, 10.000000)",
    fill: "#A6ACBA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.187,0.155 L89.373,10.655 L89.373,31.655 L71.187,42.155 L53,31.655 L53,10.655 L71.187,0.155 Z M123.187,0.155 L141.373,10.655 L141.373,31.655 L123.187,42.155 L105,31.655 L105,10.655 L123.187,0.155 Z M18.187,49.155 L36.373,59.655 L36.373,80.655 L18.187,91.155 L0,80.655 L0,59.655 L18.187,49.155 Z M71.187,49.155 L89.373,59.655 L89.373,80.655 L71.187,91.155 L53,80.655 L53,59.655 L71.187,49.155 Z M123.187,49.155 L141.373,59.655 L141.373,80.655 L123.187,91.155 L105,80.655 L105,59.655 L123.187,49.155 Z M18.187,99.155 L36.373,109.655 L36.373,130.655 L18.187,141.155 L0,130.655 L0,109.655 L18.187,99.155 Z M71.187,99.155 L89.373,109.655 L89.373,130.655 L71.187,141.155 L53,130.655 L53,109.655 L71.187,99.155 Z M123.187,99.155 L141.373,109.655 L141.373,130.655 L123.187,141.155 L105,130.655 L105,109.655 L123.187,99.155 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#A6ACBA",
    fillRule: "nonzero",
    cx: 224,
    cy: 247.5,
    rx: 147,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.224,29.512 C66.1039994,28.2639938 66.1639988,27.2020044 66.404,26.326 C66.6440012,25.4499956 66.9739979,24.6940032 67.394,24.058 C67.8140021,23.4219968 68.2939973,22.8700023 68.834,22.402 C69.3740027,21.9339977 69.8779977,21.4840022 70.346,21.052 C70.8140023,20.6199978 71.2039984,20.1700023 71.516,19.702 C71.8280016,19.2339977 71.984,18.6760032 71.984,18.028 C71.984,17.1879958 71.7500023,16.5160025 71.282,16.012 C70.8139977,15.5079975 69.980006,15.256 68.78,15.256 C68.3959981,15.256 67.9880022,15.2979996 67.556,15.382 C67.1239978,15.4660004 66.6920022,15.5859992 66.26,15.742 C65.8279978,15.8980008 65.414002,16.077999 65.018,16.282 C64.621998,16.486001 64.2680016,16.6959989 63.956,16.912 L62.156,13.456 C63.0680046,12.8319969 64.1179941,12.316002 65.306,11.908 C66.4940059,11.499998 67.9279916,11.296 69.608,11.296 C71.8640113,11.296 73.6279936,11.8419945 74.9,12.934 C76.1720064,14.0260055 76.808,15.4959908 76.808,17.344 C76.808,18.5680061 76.6460016,19.581996 76.322,20.386 C75.9979984,21.190004 75.5960024,21.8739972 75.116,22.438 C74.6359976,23.0020028 74.1080029,23.4999978 73.532,23.932 C72.9559971,24.3640022 72.4280024,24.8259975 71.948,25.318 C71.4679976,25.8100025 71.0600017,26.3799968 70.724,27.028 C70.3879983,27.6760032 70.22,28.503995 70.22,29.512 L66.224,29.512 Z M65.504,34.624 C65.504,33.7839958 65.7679974,33.1180025 66.296,32.626 C66.8240026,32.1339975 67.5199957,31.888 68.384,31.888 C69.2960046,31.888 70.0159974,32.1339975 70.544,32.626 C71.0720026,33.1180025 71.336,33.7839958 71.336,34.624 C71.336,35.4640042 71.0720026,36.1359975 70.544,36.64 C70.0159974,37.1440025 69.2960046,37.396 68.384,37.396 C67.5199957,37.396 66.8240026,37.1440025 66.296,36.64 C65.7679974,36.1359975 65.504,35.4640042 65.504,34.624 Z",
    id: "?",
    fill: "#AFB5C2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingThings);
export default __webpack_public_path__ + "static/media/missing-things.ad207df6eb28a64f0be26629162f8797.svg";
export { ForwardRef as ReactComponent };